<template lang="">
    <div>
      <LaudoInsercaoDeDiuGuiadoPorTransvaginal></LaudoInsercaoDeDiuGuiadoPorTransvaginal>
    </div>
  </template>
  <script>
  import LaudoInsercaoDeDiuGuiadoPorTransvaginal from '../components/laudos/formularios/exames/insercaoDeDiuGuiadoPorTransvaginal/LaudoInsercaoDeDiuGuiadoPorTransvaginal.vue';
  export default {
    components: {
        LaudoInsercaoDeDiuGuiadoPorTransvaginal,
    },
  };
  </script>
  <style lang=""></style>
  